import React, { useEffect, useState } from 'react';
import {
  forEach,
  isArray,
  isObject,
  camelCase,
  sortBy,
  isEqual,
  snakeCase,
  isEmpty,
  differenceWith
} from 'lodash';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import {
  IdentityArr,
  AddressArr,
  PACKAGE_UNIT_INDICATION,
  PACKAGE_UNIT_INDICATION_FACTOR,
  TDS_OPTIONS,
  ADC_TYPES
} from '../utils/commonConstant';
import localStorage from '../api/localStorage';
import { toast } from 'react-toastify';
import AppConstants from '../core-components/AppConstants';
import moment from 'moment';
let checksForExternalCompanies = 3;
export const toCamelCase = (snake_case_object) => {
  var camelCaseObject = {};
  forEach(snake_case_object, function (value, key) {
    if (isArray(value)) {
      value = value.map((v) => {
        return toCamelCase(v);
      });
    } else if (isObject(value)) {
      value = toCamelCase(value);
    }
    camelCaseObject[camelCase(key)] = value;
  });
  return camelCaseObject;
};

export const toCamelCaseTemp = (snake_case_object) => {
  var camelCaseObject = {};
  forEach(snake_case_object, function (value, key) {
    if (isArray(value)) {
      value = value.map((v) => {
        return isObject(v) ? toCamelCaseTemp(v) : v;
      });
    } else if (isObject(value)) {
      value = toCamelCaseTemp(value);
    }
    camelCaseObject[camelCase(key)] = value;
  });
  return camelCaseObject;
};

export const toSnakeCase = (camel_case_object) => {
  var snakeCaseObject = {};
  forEach(camel_case_object, function (value, key) {
    if (isArray(value)) {
      value = value.map((v) => {
        return isObject(v) ? toSnakeCase(v) : v;
      });
    } else if (isObject(value)) {
      value = toSnakeCase(value);
    }
    snakeCaseObject[snakeCase(key)] = value;
  });
  return snakeCaseObject;
};

export const getErrorMessage = (error) => {
  console.error('Error : ', error);
  if (error?.response?.data || error?.data || (error?.errors && error?.errors?.length)) {
    const errorObject =
      (error?.data && error?.data?.errorMessage) ||
      error?.response?.data?.message ||
      error?.response?.data?.errorMsg ||
      (Array.isArray(error?.response?.data?.errors) &&
        error?.response?.data?.errors?.length &&
        error?.response?.data?.errors[0]?.msg) ||
      error?.response?.data?.msg ||
      error?.response?.data ||
      error?.errors[0]?.msg ||
      'Something went wrong.';

    switch (typeof errorObject) {
      case 'object':
        return (
          errorObject?.msg ||
          JSON.stringify(errorObject.msg) ||
          errorObject?.data?.msg ||
          errorObject?.resp?.msg
        );
      case 'string':
        return errorObject;
      default:
        return 'Something went wrong.';
    }
  } else {
    if (typeof error === 'string') {
      return error;
    }
    return 'Something went wrong.';
  }
};

// Prevent duplicate error toasts

export const getMessageIdForToast = (message) => {
  if (message) return message.replace(/ +/g, '_').toLowerCase();
  return '';
};

export const errToastMessage = (err) => {
  const message = getErrorMessage(err);

  if (message) {
    const id = getMessageIdForToast(message);
    toast.error(message, { toastId: id });
  }
};

export const parseCompanyServices = (services) => {
  return sortBy(services, (service) => service.serviceId)
    .filter(
      (service) =>
        service.service &&
        service.service.status &&
        parseInt(service.service.status) !== parseInt(checksForExternalCompanies)
    )
    .map((service) => {
      if (service.serviceId === 1) {
        return {
          id: service.serviceId,
          name: service.companyServiceName,
          identities: service.identities,
          isSelected: service.defaultService === 1 ? true : false
        };
      } else {
        return {
          id: service.serviceId,
          name: service.companyServiceName,
          isSelected: service.defaultService === 1 ? true : false
        };
      }
    });
};

/**
 * Validates phone number
 * case 1: if input given contains intl number(eg:+15417543010),checks for validity
 * case 2: if local string(eg:9892782982) is given parses the number with default code(i.e india) and checks validity
 * @param   {string} phoneNumber
 * @return  {boolean}
 */
export const isValidPhoneNumber = (value) => {
  const regexForTenDigit = /^[6-9]{1}[0-9]{9}/;
  const regexForAllowedCharacter = /^[0-9+]+$/;
  try {
    let parsedPhone = null;
    let country;
    let phone = value.toString();

    // Numbers without country codes ( assuming indian numbers )
    if (phone[0] !== '+' && Number.isInteger(parseInt(phone[0], 10))) {
      if (phone.length === 10 && phone.match(regexForTenDigit)) {
        phone = `+91${phone}`;
      } else if (phone[0] === '0' && phone.slice(1).match(regexForTenDigit)) {
        phone = `+91${phone.slice(1)}`;
      } else {
        return false;
      }
    }
    if (phone.slice(0, 3) === '+91') {
      // library was allowing indian numbers with less than 10 digits
      if (!phone.slice(3).match(regexForTenDigit)) {
        return false;
      }
      country = 'IN';
    }

    if (!phone.match(regexForAllowedCharacter)) {
      return false;
    }
    // parse number ( parses numbers in specific formats also e.g. (+91) 123 456 7890 )
    // also parses numbers with different country codes
    parsedPhone = parsePhoneNumberFromString(phone, country);

    // validate the parsed number
    if (parsedPhone == undefined || (parsedPhone && !parsedPhone.isValid())) {
      return false;
    }

    return true;
  } catch (err) {
    // try catch block was required because parsePhoneNumber throws an error if number is invalid
    return false;
  }
};

// This function return boolen value by validating trimmed  phone number with country code
export const isTrimmedPhoneValid = (countryCode, phone, setFieldValue, fieldName) => {
  const trimmedVal = getTrimmedValue(phone, false);
  const IntlNumber = `${countryCode + '' + trimmedVal}`;
  if (!isValidPhoneNumber(IntlNumber)) {
    setFieldValue(fieldName, false);
  } else {
    setFieldValue(fieldName, true);
  }
  if (!trimmedVal) {
    setFieldValue(fieldName, true);
  }
};
/**
 * Returns proper international phonenumber
 * case 1: if input given contains intl number(eg:+15417543010),checks for validity
 * case 2: if local string(eg:9892782982) is given parses the number with default code(i.e india) and checks validity
 * @param   {string} phoneNumber
 * @return  {string} intlphoneNumber
 */
export const getIntlPhoneNumber = (phoneNumber) => {
  var intlphoneNumber = phoneNumber;
  var numberObj = null;
  if (phoneNumber?.length > 10) {
    //when number contains countrycode but not E164 number format
    if (!phoneNumber.startsWith('+')) {
      phoneNumber = `+${phoneNumber}`;
    }
    numberObj = parsePhoneNumberFromString(phoneNumber);
  } else {
    //adding 'IN' as code if country code is present
    numberObj = parsePhoneNumberFromString(phoneNumber, 'IN');
  }
  if (numberObj) {
    intlphoneNumber = numberObj.number;
  }

  return intlphoneNumber;
};
/**
 * Returns a number obj
 * case 1: if input given contains intl number(eg:+15417543010),checks for validity
 * case 2: if local string(eg:9892782982) is given parses the number with default code(i.e india) and checks validity
 * @param   {string} phoneNumber
 * @return  {object} numberObj
 */
export const getIntlPhoneNumberObject = (phoneNumber, countryCode = '') => {
  var numberObj = null;

  if (phoneNumber.length > 10) {
    //when number contains countrycode but not E164 number format
    if (!phoneNumber.startsWith('+') && !countryCode) {
      phoneNumber = `+${phoneNumber}`;
    } else {
      phoneNumber = `${countryCode}${phoneNumber}`;
    }
    numberObj = parsePhoneNumberFromString(phoneNumber);
  } else if (phoneNumber.length === 10 && !countryCode) {
    // When there is no country code and phone number length is 10 adding default +91 country code
    numberObj = getIntlPhoneNumberObjectWithCountryCode(phoneNumber, '+91');
  } else {
    //adding 'IN' as code if country code is present
    numberObj = getIntlPhoneNumberObjectWithCountryCode(phoneNumber, countryCode);
  }
  return numberObj;
};

export const getIntlPhoneNumberObjectWithCountryCode = (phoneNumber, countryCode) => {
  var numberObj = null;
  phoneNumber = `${countryCode + phoneNumber}`;
  numberObj =
    parsePhoneNumberFromString(phoneNumber) || parsePhoneNumberFromString(phoneNumber, countryCode);
  return numberObj;
};

export const compareObjects = (obj1, obj2) => isEqual(obj1, obj2);

//jwt parser to fetch candidate id in BGV
export const jwtParser = (token) => {
  try {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
  } catch (e) {
    return null;
  }
};

/**
 * Returns a total any count
 * @param   {array} values
 * @return  {integer}
 */
export const getAnyCount = (values = []) => {
  let count = 0,
    str = values.filter((val) => {
      if (val && val.match(/ANY_/g)) return val;
    });
  count = str && str[0] ? str[0].split('_')[1] || 0 : 0;
  return parseInt(count);
}; //end of getAnyCount

export const getAnyCountAddressCourt = (values = []) => {
  let count = 0,
    str = values.filter((val) => {
      if (val?.type.match(/ANY_/g)) return val;
    });
  count = str && str[0] ? str[0]?.type?.split('_')[1] || 0 : 0;
  return parseInt(count);
}; //end of getAnyCountAddressCourt

/**
 * Returns a check count
 * @param   {array} values
 * @return  {integer}
 */
export const getTotalAnyCount = (values = []) => {
  let count = 0,
    totalCount = 0,
    str = values.filter((val) => {
      if (val && val.match(/ANY_/g)) return val;
    });
  count = str && str[0] ? str[0].split('_')[1] : 0;
  if (count) {
    totalCount = values.length - 1 + parseInt(count);
  } else {
    totalCount = values.length;
  }
  return parseInt(totalCount);
}; //end of getTotalAnyCount

/**
 * Returns a package is cutomizable or not
 * @param   {object} config
 * @return  {boolean}
 */
export const isCustomisable = (config = {}) => {
  if (
    config.reference &&
    (config.referenceType === 'SPECIFIC' || config.referenceType === 'TOTAL')
  ) {
    return true;
  }
  if (config.identity && config.identity.length && getAnyCount(config.identity)) {
    return true;
  }
  if (
    (config.address &&
      config.address.length === 1 &&
      getAnyCountAddressCourt(config.address) === 1) ||
    (config.court && config.court.length === 1 && getAnyCountAddressCourt(config.court) === 1)
  ) {
    return true;
  }
}; //end of isCustomisable

// Return total count of array of integer
export const getCount = (arr = []) => {
  const count = arr.reduce((acc, item) => {
    return acc + parseInt(item);
  }, 0);

  return count;
};

export const getFilteredChecks = (checks = [], type = '') => {
  let strArr = [];
  const isAnyExist = checks.join(',').match(/ANY_/g) ? true : false;
  const isAllId = checks.includes('ALL');
  if (checks.length && isAnyExist && type) {
    if (type.toLowerCase() === 'identity') {
      strArr = Object.values(IdentityArr).filter((item) => {
        return !checks.includes(item);
      });
    } else if (type.toLowerCase() === 'address' || type.toLowerCase() === 'court') {
      strArr = Object.keys(AddressArr).filter((item) => {
        return !checks.includes(item);
      });
    }

    return strArr;
  } else if (isAllId) {
    strArr = Object.values(IdentityArr).filter((item) => {
      return item;
    });
    return strArr;
  } else {
    return null;
  }
};

export const isMobileTablet = () => {
  var check = false;

  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);

  return check;
};

export const showAddOnLabel = (addon) => {
  const addOnCases = {
    address: addon['address'].length,
    cibil: addon['cibil'].cost,
    court: addon['court'].length,
    custom: addon['custom'].length,
    drug: addon['drug'].length,
    education: addon['education']?.cost || addon['education']?.config?.length,
    employment: addon['employment'].cost,
    identity: addon['identity'].length,
    reference: addon['reference'].length,
    world: addon['world'].cost
  };

  for (let check in addon) {
    if (addOnCases[check]) {
      return true;
    }
  }
  return false;
};
export const getCustomCheckSVG = (
  color = '#999999',
  width = '35px',
  height = '18px',
  cursor = 'default'
) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 94 94'
      fill={'none'}
      style={{ display: 'inline-block', verticalAlign: 'middle', cursor: cursor }}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M54.6924 93.1533H39.3077C38.1539 93.1533 37.3847 92.3838 37.3847 91.2305V86.2305C33.3462 85.2686 29.6923 83.7305 26.0385 81.6152L22.577 85.0762C21.8077 85.8457 20.6539 85.8457 19.8847 85.0762L8.9231 74.1152C8.1539 73.3457 8.1539 72.1924 8.9231 71.4229L12.3847 67.9609C10.2693 64.3076 8.7308 60.6533 7.7693 56.6152H2.76927C1.61542 56.6152 0.846191 55.8457 0.846191 54.6924V39.3076C0.846191 38.1533 1.61542 37.3838 2.76927 37.3838H7.7693C8.7308 33.3457 10.2693 29.6924 12.3847 26.0381L8.9231 22.5762C8.1539 21.8076 8.1539 20.6533 8.9231 19.8838L19.8847 8.92285C20.077 8.53809 20.6539 8.3457 21.2308 8.3457C21.8077 8.3457 22.1923 8.53809 22.577 8.92285L26.0385 12.3838C29.6923 10.2686 33.3462 8.73047 37.3847 7.76855V2.76855C37.3847 1.61523 38.1539 0.845703 39.3077 0.845703H54.6924C55.8462 0.845703 56.6154 1.61523 56.6154 2.76855V7.76855C60.6539 8.73047 64.3077 10.2686 67.9616 12.3838L71.4231 8.92285C72.1924 8.15332 73.3462 8.15332 74.1154 8.92285L85.077 19.8838C85.8462 20.6533 85.8462 21.8076 85.077 22.5762L81.6154 26.0381C83.7308 29.5 85.2693 33.3457 86.2308 37.3838H91.2308C92.3847 37.3838 93.1539 38.1533 93.1539 39.3076V54.6924C93.1539 55.8457 92.3847 56.6152 91.2308 56.6152H86.2308C85.2693 60.6533 83.7308 64.3076 81.6154 67.9609L85.077 71.4229C85.8462 72.1924 85.8462 73.3457 85.077 74.1152L74.1154 85.0762C73.3462 85.8457 72.1924 85.8457 71.4231 85.0762L67.9616 81.6152C64.5 83.7305 60.6539 85.2686 56.6154 86.2305V91.2305C56.6154 92.3838 55.8462 93.1533 54.6924 93.1533ZM41.4231 89.3076H52.7693V84.6924C52.7693 83.7305 53.3462 82.9609 54.3077 82.7686C58.9231 81.8076 63.1539 80.0762 67.1924 77.3838C67.9616 76.8076 68.9231 77 69.6924 77.5762L72.9616 80.8457L81.0385 72.7686L77.7693 69.499C77.1924 68.9229 77 67.7686 77.577 67C80.2693 63.1533 82 58.7305 82.9616 54.1152C83.1539 53.1533 83.9231 52.5762 84.8847 52.5762H89.3077V41.0381H84.6924C83.7308 41.0381 82.9616 40.4609 82.7693 39.499C81.8077 34.8838 80.077 30.6533 77.3847 26.6152C76.8077 25.8457 77 24.8838 77.577 24.1152L80.8462 20.8457L72.7693 12.7686L69.5 16.2305C68.9231 16.8076 67.7693 16.999 67 16.4229C63.1539 13.7305 58.7308 11.999 54.1154 11.0381C53.1539 10.8457 52.577 10.0762 52.577 9.11523V4.69141H41.0385V9.30762C41.0385 10.2686 40.4616 11.0381 39.5 11.2305C34.8847 12.1924 30.6539 13.9229 26.6154 16.6152C25.8462 17.1924 24.8847 16.999 24.1154 16.4229L20.8462 13.1533L12.7693 21.2305L16.0385 24.499C16.6154 25.0762 16.8077 26.2305 16.2308 27C13.5385 30.8457 11.8077 35.2686 10.8462 39.8838C10.6539 40.8457 9.8847 41.4229 8.9231 41.4229H4.69235V52.9609H9.30771C10.2693 52.9609 11.0385 53.5381 11.2308 54.499C12.1923 59.1152 13.9231 63.3457 16.6154 67.3838C17.1923 68.1533 17 69.1152 16.4231 69.8838L13.1539 73.1533L21.2308 81.2305L24.5 77.9609C25.077 77.3838 26.2308 77.1924 27 77.7686C30.8462 80.4609 35.2693 82.1924 39.8847 83.1533C40.8462 83.3457 41.4231 84.1152 41.4231 85.0762V89.3076ZM47.0009 75.8438C31.0394 75.8438 18.1548 62.959 18.1548 46.9971C18.1548 31.0361 31.0394 18.1514 47.0009 18.1514C62.9625 18.1514 75.8471 31.0361 75.8471 46.9971C75.8471 62.959 62.9625 75.8438 47.0009 75.8438ZM47.0009 21.9971C33.1548 21.9971 22.0009 33.1514 22.0009 46.9971C22.0009 60.8438 33.1548 71.9971 47.0009 71.9971C60.8471 71.9971 72.0009 60.8438 72.0009 46.9971C72.0009 33.1514 60.8471 21.9971 47.0009 21.9971ZM61.2314 40.3301C61.2314 42.4824 59.703 44.2754 57.6734 44.6885V62.5664H55.0054V44.4033C53.4366 43.7158 52.3374 42.1533 52.3374 40.3311C52.3374 38.5088 53.4366 36.9463 55.0054 36.2588V31.4365H57.6734V35.9727C59.7034 36.3857 61.2314 38.1787 61.2314 40.3301ZM56.7842 38.5518C55.8038 38.5518 55.0054 39.3506 55.0054 40.3311C55.0054 41.3115 55.8038 42.1094 56.7842 42.1094C57.7646 42.1094 58.563 41.3115 58.563 40.3311C58.563 39.3506 57.7646 38.5518 56.7842 38.5518ZM41.6636 53.6719C41.6636 51.5205 40.1356 49.7275 38.1064 49.3145V31.4365H35.4376V49.5996C33.8688 50.2871 32.7696 51.8496 32.7696 53.6719C32.7696 55.4941 33.8688 57.0566 35.4376 57.7441V62.5664H38.1064V58.0293C40.1356 57.6172 41.6636 55.8232 41.6636 53.6719ZM35.438 53.6719C35.438 52.6914 36.2364 51.8926 37.2168 51.8926C38.1972 51.8926 38.9956 52.6914 38.9956 53.6719C38.9956 54.6533 38.1972 55.4502 37.2168 55.4502C36.2364 55.4502 35.438 54.6533 35.438 53.6719ZM47.8903 42.4844C49.4583 43.1719 50.5583 44.7344 50.5583 46.5566C50.5583 48.3789 49.4583 49.9414 47.8903 50.6289V62.5664H45.2215V50.9141C43.1923 50.501 41.6635 48.708 41.6635 46.5566C41.6635 44.4053 43.1927 42.6113 45.2215 42.1992V31.4365H47.8903V42.4844ZM46.1111 44.7773C45.1299 44.7773 44.3323 45.5762 44.3323 46.5566C44.3323 47.5371 45.1299 48.3359 46.1111 48.3359C47.0915 48.3359 47.8899 47.5371 47.8899 46.5566C47.8899 45.5762 47.0915 44.7773 46.1111 44.7773Z'
        fill={color}
      />
    </svg>
  );
};

export const getIDCheck = (check) => {
  if (check === 1) {
    return 'ANY';
  } else if (check === 2) {
    return 'PAN Card';
  } else if (check === 3) {
    return 'Driving License';
  } else if (check === 4) {
    return 'Passport';
  } else if (check === 5) {
    return 'Voter ID';
  } else if (check === 6) {
    return 'Aadhaar';
  }
};
export const getStatus = (status) => {
  if (status === null || status === '') {
    status = 15;
  } else if (status === -1) {
    status = 13;
  } else if (status === -2) {
    status = 14;
  }
  return parseInt(status);
};

export const getIdentityAnyCounter = (identity = []) => {
  let count = 0;
  const str = identity.find((item) => item.includes('ANY_'));
  count = str && str.substr(str.length - 1);
  return count ? parseInt(count) : 0;
};

export const getTotalCheckCount = (checks = []) => {
  let total = checks.length;
  let anyCount = getIdentityAnyCounter(checks);
  if (anyCount) {
    total = total + anyCount - 1;
  }
  return parseInt(total);
};

// Filter object by key
export const filterObjectByKeyCaseInsensitive = (obj, filterKey = '', exactMatch = false) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([key, value]) => {
      if (exactMatch) {
        return key.toLowerCase() == filterKey.toLowerCase();
      } else {
        return key.toLowerCase().includes(filterKey.toLowerCase());
      }
    })
  );
};

export const getPackageType = () => {
  const token = localStorage.getToken();
  const parsedJwtDetail = jwtParser(token);
  return parsedJwtDetail?.data?.modelType || '';
};

export function useDebounce(value, delay) {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(
    () => {
      // Update debounced value after delay
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      // Cancel the timeout if value changes (also on delay change or unmount)
      // This is how we prevent debounced value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay] // Only re-call effect if value or delay changes
  );
  return debouncedValue;
}

// calculate TDS for company
export const calculateTDS = (amount, companyTds) => {
  return amount > 0 ? parseFloat(parseFloat(amount * (companyTds / 100)).toFixed(2)) : 0;
};
// calculate Tax for company
export const calculateTax = (amount, companyTax) => {
  return parseFloat(parseFloat(amount * (companyTax / 100)).toFixed(2)) || 0;
};

/**
 *  TDS otpion based on config from SA side
 *  case 1 : TDS selected as both = then all three option will come [None,2%,10%]
 *  case 2 : TDS selected as 2% = then [None,2%] options will come
 *  case 3 : TDS selected as 10% = then [None,10%] options will come
 */
export const getTdsOptions = (value, disableOption = false) => {
  const options = [...TDS_OPTIONS];
  if (value === 'BOTH') {
    return disableTdsOptions(options, disableOption);
  } else if (value === '2') {
    return disableTdsOptions(
      options.filter((opt) => opt.value != 10),
      disableOption
    );
  } else if (value === '10') {
    return disableTdsOptions(
      options.filter((opt) => opt.value != 2),
      disableOption
    );
  }
};

// this funtion is used to disable TDS radio options other NONE option, if "Use credit balance" checkbox selected
export const disableTdsOptions = (options, disableOption) => {
  options.forEach((opt) => {
    opt.disable = disableOption && opt.value != 'NONE' ? true : false;
  });
  return options;
};

/**
 *  return intial tds value for radio options based on SA side config
 */
export const getCompanyTds = (tdsValue) => {
  return tdsValue === 'BOTH'
    ? 'NONE'
    : tdsValue === '2'
    ? '2'
    : tdsValue === '10'
    ? '10'
    : tdsValue === 'NONE'
    ? 'NONE'
    : 'NONE';
};
export const getPackageUnitIndication = (lowestUnit, packageBalance, candidateCount = 0) => {
  const indicationRange = Math.floor(
    Number.parseFloat(lowestUnit * PACKAGE_UNIT_INDICATION_FACTOR)
  );
  const packageUnitBalanceAfterCandidateAddition = packageBalance - candidateCount;

  if (packageBalance === 0 || packageUnitBalanceAfterCandidateAddition < 0) {
    return PACKAGE_UNIT_INDICATION.NILL;
  } else if (
    indicationRange >= packageBalance ||
    packageUnitBalanceAfterCandidateAddition <= indicationRange
  ) {
    return PACKAGE_UNIT_INDICATION.LOW;
  } else {
    return PACKAGE_UNIT_INDICATION.SUFFICIENT;
  }
};

// to add commos to value as per Indian Numeration
export const convertToIndianNumeration = (value, decimal) => {
  if (value) {
    value = value.toFixed(2);
  }
  return value
    ? parseFloat(value).toLocaleString('en-IN', { minimumFractionDigits: decimal ? decimal : 0 })
    : 0;
};

export const indianNumerationValue = (value, decimal) => {
  if (value) {
    value = value.toFixed(2);
  }

  return (
    <>
      &#8377;
      {value
        ? parseFloat(value).toLocaleString('en-IN', {
            minimumFractionDigits: decimal ? decimal : 0
          })
        : 0}
    </>
  );
};

export const hasDot = (value) => {
  value = value && value.toString();

  return value && value.includes('.');
};

export const copyToClipboard = (text) => {
  const type = 'text/plain';
  const blob = new Blob([text], { type });
  if (!navigator?.clipboard?.write) {
    // Clipboard API not supported in this browser
    errToastMessage('Clipboard API is not supported in this browser!');
    return;
  }
  const data = [new ClipboardItem({ [type]: blob })];
  try {
    navigator?.clipboard.write(data).then(() => {
      toast.info('Copied to Clipboard!');
    });
  } catch (error) {
    errToastMessage('Copying was unsuccessful!');
  }
};

export const checkForLeadingOrTrailingWhiteSpace = (value) => {
  const length = value?.length;

  if (length) {
    return value[0] === ' ' || value[length - 1] == ' ';
  }
  return false;
};

export const getTrimmedValue = (value, withSpace) => {
  if (value) {
    return withSpace ? value.trim().replace(/\s\s+/g, ' ') : value.trim().replace(/\s+/g, '');
  } else {
    return '';
  }
};

// Using this function will retain the new lines in the text
export const getTrimmedValueWithNewLines = (value, withSpace) => {
  if (value) {
    if (withSpace) {
      return value
        .replace(/^[ \t]+|[ \t]+$/gm, '')
        .replace(/\n[ \t]+/g, '\n')
        .replace(/[ \t]+/g, ' ')
        .split('\n')
        .filter((line) => line.trim() !== '')
        .join('\n');
    } else {
      return value.replace(/^[ \t]+|[ \t]+$/gm, '');
    }
  } else {
    return '';
  }
};

// export const getTrimmedValueWithSpace = (value) => getTrimmedValue(value, true);

// export const getTrimmedValueWithNoSpace = (value) => getTrimmedValue(value, false);
export const getFileHeader = (header) => {
  let fileType = '';
  switch (header) {
    case '89504e47':
      fileType = 'image/png';
      break;
    case 'ffd8ffe0':
    case 'ffd8ffe1':
    case 'ffd8ffe2':
    case 'ffd8ffe3':
    case 'ffd8ffe8':
      fileType = 'image/jpeg';
      break;
    case '25504446':
      fileType = 'application/pdf';
      break;
    default: // Or you can use the blob.fileType as fallback
      fileType = 'unknown';
      break;
  }
  return fileType;
};
export const validateImage = (fileArr, fileType) => {
  let errMessage = '';
  let extensionArr = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'image/heic'];
  const size = parseInt(fileArr.size / 1024);
  const extension = fileType;
  if (size < AppConstants.fileSize && extension !== 'application/pdf') {
    errMessage = 'FILE_SIZE_EXCEEDS';
  } else if (!extensionArr.includes(extension)) {
    errMessage = 'FILE_TYPE_MISMATCH';
  }
  return errMessage;
};

export const FileErrorMeaage = {
  FILE_SIZE_EXCEEDS:
    'Upload failed. Please upload a file that exceeds ' + AppConstants.fileSize + 'KB',
  FILE_TYPE_MISMATCH: 'Upload failed. File format not valid.'
};

export const getDescription = (usage) => {
  const checkType = usage?.checkType === 'CIBIL' ? 'Credit Check' : usage.checkType;

  switch (usage.event) {
    case 'CREDIT_NOTE':
      const detailsInvoice = usage?.invoiceDetails;
      let text = '';
      if (detailsInvoice) {
        const invoiceDate = moment(detailsInvoice?.invoiceDate).format('DD-MM-YYYY');
        text = `(Inv No. ${detailsInvoice?.invoiceNumber || ''} : ${invoiceDate})`;
      }
      return `Credit Note ${text}`;
    case 'PACKAGE_BOUGHT':
      return `${usage.packageDetails?.name}`;
    case 'ADDON_BOUGHT':
      return `${checkType}`;
    case 'ADDITIONAL_CHARGE':
      return `${ADC_TYPES[usage?.paymentsCompanyAdditionalCharge?.chargeType]}: ${
        checkType || 'N/A'
      }`;
    case 'ADDITIONAL_CHARGE_REFUND':
      return `${ADC_TYPES[usage?.paymentsCompanyAdditionalCharge?.chargeType]}: ${
        checkType || 'N/A'
      }`;
    case 'CHECK_REFUND':
      return `${checkType}`;
    case 'PACKAGE_UNITS_CONVERTED_TO_CREDITS':
      return `${usage.packageDetails?.name}`;
    case 'CHECK_VERIFICATION_TYPE_CONVERSION':
      return `${usage.checkType}`;
    default:
    case 'CREDITS_LOCKED':
    case 'CREDITS_UNLOCKED':
      return usage?.prepaidInvoiceDetails?.proformaNumber ? (
        <a
          href={`${AppConstants.baseURL}proforma-invoice?invoiceId=${usage?.prepaidInvoiceDetails?.proformaNumber}`}
          target='_blank'
          style={{
            color: '#2755fe'
          }}
        >
          {usage?.prepaidInvoiceDetails?.proformaNumber}
        </a>
      ) : (
        '-'
      );
    case 'ALUMNI_VERIFICATION_BONUS':
      return 'Credits Earned';
  }
};

export const hasPaymentGatewayMethod = (transactions) => {
  if (Array.isArray(transactions)) {
    return transactions.some((transaction) => transaction.method === 'PAYMENT_GATEWAY');
  } else if (typeof transactions === 'object') {
    return transactions.method === 'PAYMENT_GATEWAY';
  }
  return false;
};

export const getPassportIdValidity = (value) => {
  let spaceIndex = -1;
  if (!value) {
    return {
      error: true,
      msg: 'Passport number is required.'
    };
  } else if (value) {
    spaceIndex = value.indexOf(' ');
    if (spaceIndex >= 0 || !value.match('^[a-zA-Z0-9-]+$')) {
      return {
        error: true,
        msg: 'Please enter valid Passport number'
      };
    } else {
      return {
        error: false,
        msg: ''
      };
    }
  }
};

// Covert to comma separated string
export const convertToCommaSeparateString = (value) => {
  if (value) {
    return parseInt(value.replace(/,/g, '')).toLocaleString('en-IN');
  } else {
    return '';
  }
};

export const getCityValue = (data) => {
  if (!isEmpty(data) && data.endsWith('*')) {
    return data.slice(0, -1);
  }
  return data;
};

export const removeAsterisksFromString = (param) => {
  return !isEmpty(param) ? param.replace(/\*/g, '') : '';
};

// Covert to Object to Query string
export const covertObjToQueryString = (obj) => {
  if (obj && typeof obj === 'object') {
    return Object.keys(obj)
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
      .join('&');
  } else {
    return '';
  }
};

// Covert Query string to Object
export const covertQueryStringToObject = (queryString) => {
  const params = new URLSearchParams(queryString);
  const result = {};
  for (const [key, value] of params) {
    result[key] = result.hasOwnProperty(key)
      ? Array.isArray(result[key])
        ? [...result[key], value]
        : [result[key], value]
      : value;
  }
  return result;
};

export const getPlaceHolderTextForBgvCityDropDown = (cities) => {
  return !isEmpty(cities) ? 'Select' : 'Select or type city name';
};
export const getCourtVerificationType = (type) => {
  switch (type) {
    case 'STANDARD':
      return 'Standard';
    case 'STANDARD_LAWFIRM':
      return 'Standard via Lawfirm';
    default:
      return '-';
  }
};
export const getAddressVerificationType = (type) => {
  switch (type) {
    case 'PHYSICAL':
      return 'Physical';
    case 'DIGITAL':
      return 'Digital';
    case 'POSTAL':
      return 'Postal';
    default:
      return '-';
  }
};

export const validateCategoriesAndTags = (
  values = {},
  categoriesList = [],
  tagsList = [],
  showToastError = false
) => {
  const {
    category_id: selectedCategoryId,
    category_name: selectedCategoryName,
    tags: selectedTags
  } = values;
  const errors = {};

  if (selectedCategoryId) {
    const isCategoryAvailable = categoriesList.some((cat) => cat.id === selectedCategoryId);
    if (!isCategoryAvailable) {
      errors[
        'categoryError'
      ] = `Category "<span class='text-capitalize font-weight-bold'>${selectedCategoryName}</span>" is deleted. Please create or choose a different category.`;
      errors['deletedCategoryId'] = selectedCategoryId;
    }
  }

  if (selectedTags) {
    const comparator = (a, b) => a.id === b.id;
    const deletedTags = differenceWith(selectedTags, tagsList, comparator);
    if (deletedTags.length > 0) {
      const deletedTagNames = deletedTags.map((t) => t.category);
      const deletedItemsCount = deletedTagNames.length;
      const errorMessage = `Tag${
        deletedItemsCount >= 2 ? 's' : ''
      } <span class='text-capitalize font-weight-bold'>"${deletedTagNames.join(', ')}"</span> ${
        deletedItemsCount >= 2 ? 'are' : 'is'
      } deleted. Please create or choose a different tag${deletedItemsCount >= 2 ? 's' : ''}.`;
      errors['tagsError'] = errorMessage;
      errors['deletedTags'] = deletedTags;
    }
  }
  if (showToastError && !isEmpty(errors)) {
    toast.error(
      <>
        {errors.categoryError && (
          <div dangerouslySetInnerHTML={{ __html: errors.categoryError }}></div>
        )}
        {errors.tagsError && <div dangerouslySetInnerHTML={{ __html: errors.tagsError }}></div>}
      </>
    );
  }
  return errors;
};

export const toCamelCaseWithSpaces = (inputString) => {
  return inputString
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (match, index) => {
      return index === 0 ? match.toLowerCase() : match.toUpperCase();
    })
    .replace(/\s+/g, '');
};

//Used to get the Tat value(Turn around value) for Reference
//Used for Insufficiency time and effective time

export const tatDataFormatted = (tatDataValue, verificationInfo, key, targetIndex) => {
  let currentIndex = 0;
  for (const info of verificationInfo) {
    const matchedTatData = tatDataValue.find((tatData) => tatData.checkId === info.id);
    if (matchedTatData) {
      if (currentIndex === targetIndex) {
        return matchedTatData[key];
      }
      currentIndex++;
    }
  }
  return null;
};

export const redirectToPreviousPathAfterLogin = (history) => {
  const pathName = window.location.pathname;
  const lastPathname = window.localStorage.getItem('last-redirect-pathname') || '/dashboard';
  const lastPathnameV1 = window.localStorage.getItem('last-redirect-pathname-v1');
  if (!pathName.includes('v1') && !lastPathnameV1) {
    history?.push(lastPathname);
  } else {
    window.localStorage.removeItem('last-redirect-pathname-v1');
    setTimeout(() => {
      window.location.href = lastPathnameV1 || '/dashboard';
    }, 500);
  }
  window.localStorage.removeItem('last-redirect-pathname');
};
/**
 * Get the banners based on the conditions
 * @param {Object} paymentDetails Payment Details API Data
 * @param {Object} upsellRecommendationData Upsell Recommendation Data
 * @returns {Array} Array of Banners
 */
export const getBanners = ({
  paymentDetails = {},
  upsellRecommendationData = {},
  isCandidatePage = false
}) => {
  const isUpsellRecommendationsPaused = upsellRecommendationData?.isUpsellRecommendationsPaused;
  const isUpsellDataPresent = upsellRecommendationData?.checks?.length > 0;

  // const isReferralEnabled = paymentDetails?.isReferralEnabled;
  // const isConnectModelPaused = paymentDetails?.isConnected;
  const isAlumniVerificationEnabled = paymentDetails?.alumniVerificationEnabled;

  const upsellLaptopDisplayStartDate = new Date('2024-08-01');
  const upsellLaptopDisplayEndDate = new Date('2024-09-30');
  const currentDate = new Date();
  const MarketingBannerDisplayStartDate = new Date('2024-08-21');
  const MarketingBannerDisplayEndDate = new Date('2024-09-04');
  MarketingBannerDisplayStartDate.setHours(0, 0, 0, 0);
  MarketingBannerDisplayEndDate.setHours(23, 59, 59, 999);

  const tempBannerArray = [];

  // Upsell Laptop Banner: Show for 31 days only and on Candidate Page
  const isUpsellLaptopPeriod =
    currentDate >= upsellLaptopDisplayStartDate && currentDate <= upsellLaptopDisplayEndDate;
  if (
    isCandidatePage &&
    isUpsellLaptopPeriod &&
    !paymentDetails?.loading &&
    paymentDetails?.upsellLaptopBannerEnabled
  ) {
    return ['upsellLaptop'];
  }

  if (paymentDetails?.loading) return [];

  // Alumni Verification Banner: P1
  if (!isAlumniVerificationEnabled) {
    tempBannerArray.push('alumniVerification');
  }

  // Slack Connect Banner: P2
  // if (tempBannerArray.length < 2 && !isConnectModelPaused) {
  //   tempBannerArray.push('connect');
  // }

  // Upsell Banner: P3
  if (!isUpsellRecommendationsPaused && isUpsellDataPresent && tempBannerArray.length < 2) {
    tempBannerArray.push('upsell');
  }

  // Refer and Earn Banner: P4
  // Commmented As per Improvement 20836
  // if (isReferralEnabled && tempBannerArray.length < 2) {
  //   tempBannerArray.push('refer');
  // }

  // Marketing Banner
  if (
    currentDate >= MarketingBannerDisplayStartDate &&
    currentDate <= MarketingBannerDisplayEndDate
  ) {
    tempBannerArray.push('marketing');
  }

  // Razorpay Banner: P0, shown for two weeks only
  if (new Date() <= new Date('2024-08-09')) {
    tempBannerArray.unshift('razorpay');
  }

  return tempBannerArray;
};

export const getDateValidity = (value) => {
  let result = { error: false, msg: '' };
  if (!value) {
    return result;
  }

  const enteredDate = moment(value).format('YYYY-MM-DD');
  const currentDate = moment().format('YYYY-MM-DD');

  if (enteredDate > currentDate) {
    result = {
      error: true,
      msg: 'Date should not be future date'
    };
  } else if (enteredDate === currentDate) {
    result = {
      error: true,
      msg: 'Date should not be current date'
    };
  } else if (Math.abs(moment(enteredDate).diff(moment(currentDate), 'years')) < 10) {
    result = {
      error: true,
      msg: 'Date should be minimum 10 years old'
    };
  }

  return result;
};
